import { render, staticRenderFns } from "./PageBarriers.vue?vue&type=template&id=0aaf159a&scoped=true"
import script from "./PageBarriers.vue?vue&type=script&lang=ts"
export * from "./PageBarriers.vue?vue&type=script&lang=ts"
import style0 from "./PageBarriers.vue?vue&type=style&index=0&id=0aaf159a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf159a",
  null
  
)

export default component.exports